import axios from "axios";
import store from '../store';

export default class eSim {
    static reservaEsim() {
        if(process.env.NODE_ENV === 'development') return this.developmentReservaEsim();
        return axios.get( `../${store.getters.getConfig['reserva_url']}`)
    }

    static developmentReservaEsim() {
        return axios.get('/api/simCard/reserve')
    }
}
